import CookieService from 'commons-general/services/CookieService/CookieService.js';

const tradeInProvider = 'SM360';
// cookie from webauto
const tradeInSessionId = CookieService.get('shiftdigitalSessionId') || '';

const FORM_TYPES = {
    tradein: 'Trade In',
    login: 'Registration',
    account: 'Registration',
    appointment: 'Test Drive',
    deposit: 'Make an Offer',
    financing: 'Finance',
};
const FORM_OPTIN = {
    implicit: 'in-implicit',
    explicit: 'in-explicit',
};
const PREF_CONTACT = {
    phone: 'phone',
    email: 'email',
    text: 'text',
    other: 'other',
};

// Generic events
const FORM_SUBMISSION = (leadId, formType, formOptIn, prefContact, isModal, formVehicle, tradeInVehicle) => ({
    datalayer: {
        leadId,
        formType: FORM_TYPES[formType] || '', // restricted values
        leadType: 'lead',
        formOptIn: FORM_OPTIN[formOptIn ? 'implicit' : 'explicit'], // in-implicit | in-explicit
        prefContact: PREF_CONTACT[prefContact] || 'phone', // phone | email | text | other
        displayType: isModal ? 'modal' : 'in-page', // in-page | modal
        ...(formVehicle && { formVehicle }), // optional, if it contains vehicle info
        ...(tradeInVehicle && { tradeIn: tradeInVehicle }), // optional, if it contains tradein vehicle info
    },
    eventName: 'formSubmission',
});

const TRADEIN_TOYOTA_LEXUS_IMPRESSION = {
    datalayer: {
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInImpression',
};
const TRADEIN_TOYOTA_LEXUS_START = {
    datalayer: {
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInStart',
};
const TRADEIN_TOYOTA_LEXUS_VEHICLE_SELECTED = (tradeInYear, tradeInMake, tradeInModel) => ({
    datalayer: {
        tradeInYear,
        tradeInMake,
        tradeInModel,
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInVehicleIndicated',
});
const TRADEIN_TOYOTA_LEXUS_FORM_START = (tradeInYear, tradeInMake, tradeInModel) => ({
    datalayer: {
        tradeInYear,
        tradeInMake,
        tradeInModel,
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInFormInitiation',
});
const TRADEIN_TOYOTA_LEXUS_COMPLETE = (tradeInYear, tradeInMake, tradeInModel) => ({
    datalayer: {
        tradeInYear,
        tradeInMake,
        tradeInModel,
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInComplete',
});
const TRADEIN_TOYOTA_LEXUS_FORM_SUBMISSION = (tradeInYear, tradeInMake, tradeInModel, tradeInLeadId) => ({
    datalayer: {
        tradeInYear,
        tradeInMake,
        tradeInModel,
        tradeInLeadId,
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInFormSubmission',
});
const TRADEIN_TOYOTA_LEXUS_APPOINTMENT = (tradeInYear, tradeInMake, tradeInModel, tradeInLeadId) => ({
    datalayer: {
        tradeInYear,
        tradeInMake,
        tradeInModel,
        tradeInLeadId,
        tradeInSessionId,
        tradeInProvider,
    },
    eventName: 'tradeInApptSet',
});

const FILTER_SEARCH = (
    vehicleCount,
    currentStatus,
    minYear,
    maxYear,
    make,
    model,
    minPrice,
    maxPrice,
    bodyStyle,
    searchBar
) => ({
    datalayer: {
        countSearchResults: vehicleCount,
        filterSearch: {
            status: currentStatus,
            minYear,
            maxYear,
            make,
            model,
            minPrice,
            maxPrice,
            bodyStyle,
            searchBar,
        },
    },
    eventName: 'filterSearch',
});

const DR_PAGEVIEW_EVENT = (
    { dealId, vehicleYear, vehicleMake, vehicleModel, vehicleVin, vehicleStatus },
    initialClick
) => ({
    datalayer: {
        pageType: 'Digital Retailing',
        digRet: {
            priceUnlocked: 'True',
            dealId,
            provider: tradeInProvider,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    ...(!initialClick && { eventName: 'drInitialClick' }),
});

const DR_IMPRESSION_EVENT = ({ dealId, vehicleYear, vehicleMake, vehicleModel, vehicleVin, vehicleStatus }) => ({
    datalayer: {
        digRet: {
            priceUnlocked: 'True',
            dealId,
            provider: tradeInProvider,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drImpression',
});

const DR_INITIAL_CLICK_EVENT = ({ dealId, vehicleYear, vehicleMake, vehicleModel, vehicleVin, vehicleStatus }) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drInitialClick',
});

const DR_TRADEIN_SHOWN_EVENT = ({ dealId, vehicleYear, vehicleMake, vehicleModel, vehicleVin, vehicleStatus }) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drTradeInShown',
});

const DR_TRADEIN_START_EVENT = ({ dealId, vehicleYear, vehicleMake, vehicleModel, vehicleVin, vehicleStatus }) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drTradeInStart',
});

const DR_TRADEIN_FINISH_EVENT = ({ dealId, vehicleYear, vehicleMake, vehicleModel, vehicleVin, vehicleStatus }) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drTradeInFinish',
});

const DR_CALCULATOR_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drPaymentCalcShown',
});

const DR_CALCULATOR_START_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drPaymentCalcInteraction',
});

const DR_CALCULATOR_FINISH_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drPaymentCalcFinish',
});

const DR_LEAD_FORM_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drLeadFormShown',
});

const DR_LEAD_FORM_START_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drLeadFormStart',
});

const DR_LEAD_FORM_FINISH_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drLeadFormFinish',
});

const DR_APPOINTMENT_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drApptSchedShown',
});

const DR_APPOINTMENT_START_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drApptSchedStart',
});

const DR_APPOINTMENT_FINISH_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drApptSchedFinish',
});

const DR_PRE_Q_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drPreQShown',
});

const DR_PRE_Q_START_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drPreQStart',
});

const DR_PRE_Q_FINISH_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drPreQFinish',
});

const DR_FI_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drFiShown',
});

const DR_FI_FINISH_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drFiFinish',
});

const DR_ACCESSORIES_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drAccessoriesShown',
});

const DR_ACCESSORIES_FINISH_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drAccessoriesFinish',
});

const DR_ADD_TO_CART_EVENT = ({
    dealId,
    dealType,
    addOnName,
    addOnType = 'Accessories', // Accessories || FI
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            addOnName,
            addOnType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drAddToCart',
});

const DR_DROP_SAVE_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drDropSave',
});

const DR_CONTRACT_SHOWN_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drContractShown',
});

const DR_CONTRACT_START_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drContractStart',
});

const DR_CONTRACT_FINISH_EVENT = ({
    dealId,
    dealType,
    depositMade = 'Yes',
    depositAmt,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            depositMade,
            depositAmt,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
        },
    },
    eventName: 'drContractFinish',
});

const DR_OFFER_ADDED_EVENT = ({
    dealId,
    dealType,
    vehicleYear,
    vehicleMake,
    vehicleModel,
    vehicleVin,
    vehicleStatus,
}) => ({
    datalayer: {
        digRet: {
            provider: tradeInProvider,
            priceUnlocked: 'True',
            dealId,
            dealType,
            vehicleYear,
            vehicleMake,
            vehicleModel,
            vehicleVin,
            vehicleStatus,
            offerName: dealType,
            offerType: 'Finance',
        },
    },
    eventName: 'drOfferAdded',
});

export default {
    FORM_SUBMISSION,
    TRADEIN_TOYOTA_LEXUS_IMPRESSION,
    TRADEIN_TOYOTA_LEXUS_FORM_SUBMISSION,
    TRADEIN_TOYOTA_LEXUS_START,
    TRADEIN_TOYOTA_LEXUS_VEHICLE_SELECTED,
    TRADEIN_TOYOTA_LEXUS_FORM_START,
    TRADEIN_TOYOTA_LEXUS_COMPLETE,
    TRADEIN_TOYOTA_LEXUS_APPOINTMENT,
    FILTER_SEARCH,
    DR_PAGEVIEW_EVENT,
    DR_IMPRESSION_EVENT,
    DR_INITIAL_CLICK_EVENT,
    DR_TRADEIN_SHOWN_EVENT,
    DR_TRADEIN_START_EVENT,
    DR_TRADEIN_FINISH_EVENT,
    DR_CALCULATOR_SHOWN_EVENT,
    DR_CALCULATOR_START_EVENT,
    DR_CALCULATOR_FINISH_EVENT,
    DR_LEAD_FORM_SHOWN_EVENT,
    DR_LEAD_FORM_START_EVENT,
    DR_LEAD_FORM_FINISH_EVENT,
    DR_APPOINTMENT_SHOWN_EVENT,
    DR_APPOINTMENT_START_EVENT,
    DR_APPOINTMENT_FINISH_EVENT,
    DR_PRE_Q_SHOWN_EVENT,
    DR_PRE_Q_START_EVENT,
    DR_PRE_Q_FINISH_EVENT,
    DR_FI_SHOWN_EVENT,
    DR_FI_FINISH_EVENT,
    DR_ACCESSORIES_SHOWN_EVENT,
    DR_ACCESSORIES_FINISH_EVENT,
    DR_ADD_TO_CART_EVENT,
    DR_DROP_SAVE_EVENT,
    DR_CONTRACT_SHOWN_EVENT,
    DR_CONTRACT_START_EVENT,
    DR_CONTRACT_FINISH_EVENT,
    DR_OFFER_ADDED_EVENT,
};
